//
//  SDKWorkspaceIPWhitelistSettings.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Object Definition
export class WorkspaceIPWhitelistSettings {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        this.isEnabledForCloud = model.isEnabledForCloud;
        this.isEnabledForDocs = model.isEnabledForDocs;
        this.entries = model.entries.map((entry) => ({
            isEnabled: entry.isEnabled,
            name: entry.name,
            range: entry.range,
        }));
    }
    static initial() {
        return new WorkspaceIPWhitelistSettings({
            isEnabledForCloud: false,
            isEnabledForDocs: false,
            entries: [],
        });
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Serialization & Deserialization
    toUpdateObject() {
        return {
            isEnabledForCloud: this.isEnabledForCloud,
            isEnabledForDocs: this.isEnabledForDocs,
            entries: this.entries,
        };
    }
    toRemote() {
        return {
            isEnabledForCloud: this.isEnabledForCloud,
            isEnabledForDocs: this.isEnabledForDocs,
            entries: this.entries,
        };
    }
    toTransport() {
        return this.toRemote();
    }
    static fromTransport(model) {
        return new WorkspaceIPWhitelistSettings(model);
    }
}
